<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'/>
        <div class="row no-gutters">
            <div class="col-md-12">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                    </button>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Purpose" >
                                        <a-select
                                            labelInValue
                                            :value="purpose"
                                            placeholder="Select purpose"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPurposes"
                                            @change="selectPurpose"
                                            :notFoundContent="fetching ? undefined : null">
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in purposes" :key="'purposes'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Status" >
                                        <select class="form-control" size="large" v-model="inputStatus">
                                            <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row" v-if="$attrs.friendlyCode != 'RR' && $attrs.friendlyCode != 'RS' && $attrs.friendlyCode != 'ADI' && $attrs.friendlyCode != 'STI'">
                                <div class="col-md-7">
                                    <base-input label="Order Status" >
                                        <a-select mode="multiple" v-model="inputOrderStatus" showSearch placeholder="All Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in orderStatusOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <br>
                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                </vue-json-to-csv>
                <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                </download-excel>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';
    
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                currentDocumentTypeId: 0,
                spinning: false,
                fetching: false,
                purpose: [],
                purposes: [],
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputStatus: 'P',
                statusOptions: [
                    {key: 'P', value: 'Posted'},
                    {key: 'S', value: 'Saved'},
                    {key: 'V', value: 'Voided'}
                ],
                inputSortBy: 'id',
                sortOptions: [
                    {key: 'id', value: 'Document ID'}
                ],
                inputOrderStatus: [],
                orderStatusOptions: [
                    {key: "U", value: "Unfulfilled"},
                    {key: "G", value: "Goods Issued"},
                    {key: "F", value: "Fulfilled"},
                    {key: "O", value: "Open Delivery"},
                    {key: "S", value: "Paid"},
                    {key: "P", value: "Partial"},
                    {key: "D", value: "Done"}
                ],
                transOptions: [
                    {key: "RECADJ", value: "Adjustment In With Cost", document_name: "Adjustment In"},
                    {key: "RELADJ", value: "Adjustment Out With Cost", document_name: "Adjustment Out"}
                ],
                inputSite: [],
                site_type: "ho",
                showSortInfo: 'asc',
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: ''
            }
        },
        mounted: async function () {
            var component_x = this;
            var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
            let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).document_name
            this.currentDocumentTypeId = document_types.find(x => x.value === trans_val).key
            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
            this.reportDescription = await getReportDescription(this.currentProfile)

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            async fetchPurposes() {
                this.fetching = true
                this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes?document_type_id='+this.currentDocumentTypeId, null)
                this.purposes.push({id: -1, name: "All Purpose"})
                this.purposes.sort((a, b) => {
                    return a.id - b.id;
                });

                this.fetching = false
            },
            selectPurpose (purpose) {
                var arr = {
                    key:purpose.key.replace('purposes',''),
                    label:purpose.label
                }
                purpose = arr
                Object.assign(this, {
                    purpose,
                    purposes: [],
                    fetching: false,
                })
            },
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToQuantity(num){
                return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = null 
                let to_date = null 
                
                try {
                    from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                    to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                } catch (error) {
                    this.openNotificationWithIcon('error', 'Date range is empty.');
                    this.spinning= false;
                    return
                }
                
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&current_profile=' + this.currentProfile + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus + '&purpose=' + ((this.purpose.key == undefined) ? '-1' :  this.purpose.key), null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }
                    
                    let headers = [];
                    let header_detail = [];
                    
                    header_detail.push( 
                        {content: this.$attrs.friendlyCode + ' #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Create Date', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Post Date ', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Purpose ', styles: {halign: 'left', valign: 'center'}},
                        {content: 'Status ', styles: {halign: 'center', valign: 'center'}},
                        {content: 'References', colSpan: 2, styles: {halign: 'left', valign: 'center'}},
                        )

                    headers = [header_detail]
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_cost = 0
                            let sub_total_totalcost = 0
                            let grand_total_qty = 0
                            let grand_total_cost = 0
                            let grand_total_totalcost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                
                                if(grouper == 'start'){
                                    let doc_status = this.statusOptions.find(x => x.key === reportLine.document_status).value
                                    let h_detail = [
                                        {content: reportLine.document_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: moment(String(reportLine.document_date)).format('MMMM D, YYYY'), styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: ((reportLine.posted_at == null) ? '-' : moment(String(reportLine.posted_at)).format('MMMM D, YYYY')), styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.purpose, styles: {halign: 'left', fontStyle: 'bold'}},
                                        {content: doc_status, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.reference_1, styles: {halign: 'center', fontStyle: 'bold'}},
                                    ];
                                    reportData.push(Object.assign({}, h_detail))
                                    let site_detail = [
                                        {content: 'Site: ' + reportLine.site_name, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, site_detail))
                                    let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Stock Number', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},                
                                            ];
                            
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.document_id){
                                        let doc_status = this.statusOptions.find(x => x.key === reportLine.document_status).value
                                        let h_detail = [
                                            {content: reportLine.document_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: moment(String(reportLine.document_date)).format('MMMM D, YYYY'), styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: ((reportLine.posted_at == null) ? '-' : moment(String(reportLine.posted_at)).format('MMMM D, YYYY')), styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.purpose, styles: {halign: 'left', fontStyle: 'bold'}},
                                            {content: doc_status, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.reference_1, styles: {halign: 'center', fontStyle: 'bold'}},
                                        ];
                                        reportData.push(Object.assign({}, h_detail))
                                        let site_detail = [
                                            {content: 'Site: ' + reportLine.site_name, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, site_detail))
                                        let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Stock Number', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                           
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.document_id
                                let detail = [
                                            {content: reportLine.product_id},
                                            {content: reportLine.stock_no},
                                            {content: reportLine.barcode},
                                            {content: reportLine.product_name, styles: {halign: 'left'}},
                                            {content: this.convertToQuantity(Number(reportLine.quantity))},
                                            {content: this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z')},
                                            {content: this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost * reportLine.quantity)), 'Z')}
                                        ];

                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_cost += Number(reportLine.cost)
                                sub_total_totalcost += Number(reportLine.cost * reportLine.quantity)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_cost += Number(reportLine.cost)
                                grand_total_totalcost += Number(reportLine.cost * reportLine.quantity)

                                reportData.push(Object.assign({}, detail))
                    
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', '', 'Sub Total :', this.convertToQuantity(Number(sub_total_qty)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(sub_total_totalcost)), 'Z')]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"])) 
                                    reportData.push(Object.assign({}, ['', '', '', 'Grand Total :', this.convertToQuantity(Number(grand_total_qty)), this.addMaskValidation(this.convertToCurrency(Number(grand_total_cost)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(grand_total_totalcost)), 'Z')]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.document_id
                                    next_grouper = this.birSalesReports[i+1].document_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', '', 'Sub Total :', this.convertToQuantity(Number(sub_total_qty)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(sub_total_totalcost)), 'Z')]));

                                        sub_total_qty = 0
                                        sub_total_cost = 0
                                        sub_total_totalcost = 0
                                    }
                                }
                                    
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,trans_val + " Journal By " + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        
                        doc.text(15,25,"For the Period of " + from_date + " to " + to_date)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 40},
                            1: {cellWidth: 40},
                            2: {cellWidth: 40},
                            3: {cellWidth: 120},
                            4: {cellWidth: 25},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                        }

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            margin: {bottom: 25},
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                    
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();
                        for(let i = 0; i < pageCount; i++) { 
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, trans_val + " Journal By " + group_text, 340, 200, doc.internal.getCurrentPageInfo().pageNumber, pageCount)
                            // doc.text( 340, 210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                        }
                        

                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                let from_date = null 
                let to_date = null 
                
                try {
                    from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                    to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                } catch (error) {
                    this.openNotificationWithIcon('error', 'Date range is empty.');
                    this.spinning= false;
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&current_profile=' + this.currentProfile + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus + '&purpose=' + ((this.purpose.key == undefined) ? '-1' :  this.purpose.key), null);

                
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                let siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let headers = [ this.$attrs.friendlyCode + ' #',' Create Date ',' Post Date',' Purpose',' Status',' References',' Product Code',' Stock Number',' Barcode',' Description',' Quantity',' Cost',' Total Cost'];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_cost = 0
                            let sub_total_totalcost = 0
                            let grand_total_qty = 0
                            let grand_total_cost = 0
                            let grand_total_totalcost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [group_text + ' : ' + grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let markup_display = 0
                                let markup_percent_display = 0
                                
                                markup_display = Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)

                                if( Number(reportLine.cost * reportLine.quantity) != 0)
                                    markup_percent_display = (markup_display / Number(reportLine.cost * reportLine.quantity)) * 100
                                else 
                                    markup_percent_display = Number(0)
                                let doc_status = this.statusOptions.find(x => x.key === reportLine.document_status).value
                                let detail = [
                                    reportLine.document_id,
                                    moment(String(reportLine.document_date)).format('MMMM D, YYYY'),
                                    ((reportLine.posted_at == null) ? '-' : moment(String(reportLine.posted_at)).format('MMMM D, YYYY')),
                                    reportLine.purpose,
                                    String(doc_status),
                                    (reportLine.reference_1 + "").replace("null", ""),
                                    reportLine.product_id,
                                    reportLine.stock_no,
                                    String(reportLine.barcode),
                                    String(reportLine.product_name),
                                    Number(reportLine.quantity).toFixed(0),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost * reportLine.quantity)), 'Z')
                                ]
                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_cost += Number(reportLine.cost)
                                sub_total_totalcost += Number(reportLine.cost * reportLine.quantity)
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_cost += Number(reportLine.cost)
                                grand_total_totalcost += Number(reportLine.cost * reportLine.quantity)

                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ['', '', '', '', '', '' ,'', '', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(sub_total_totalcost)), 'Z')]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ['', '', '', '', '', '' ,'', '', '', 'Grand Total :', this.convertToCurrency(Number(grand_total_qty)), this.addMaskValidation(this.convertToCurrency(Number(grand_total_cost)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(grand_total_totalcost)), 'Z')]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), this.addMaskValidation(this.convertToCurrency(Number(sub_total_totalcost)), 'Z')]));

                                        sub_total_qty = 0
                                        sub_total_cost = 0
                                        sub_total_totalcost = 0
                                    }
                                }
                            }

                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>

<style></style>